export const INFO_TOOLTIP_CLASS_NAME = '.has-tooltip';
